import moment from "moment";
import { getUITranslation } from "../../utils/get_ui_translation";
import { open } from "../../framework/components/popup";
import * as API from "../../framework/api";
import * as Icon from "../../framework/components/icon";

const BLOCK_CLASS = "email-table-body";
const MAX_CELL_LENGTH = 200;

export function rawHTMLCellTemplate(dataElementName, classNames = null) {
  // The data used here MUST be sanitized in the backend
  return (container, info) => {
    const newContainer = document.createElement("div");
    newContainer.innerHTML = info.data[dataElementName];
    classNames && newContainer.classList.add(classNames);
    container.append(newContainer);
  };
}

async function getAttachmentFile() {
  const errorPopup = document.getElementById("email-history-error-popup");

  const path = document.getElementById("js-trainee-for-inspector")
    ? p`/inspector/request_generated_file/${this.generated_file.id}`
    : p`/training_sessions/communications/email_history_json/request_generated_file/${this.generated_file.id}`;

  const res = await API.fetch(path, {
    method: "GET",
    credentials: "same-origin",
  });

  if (res.ok) {
    const { url } = await res.json();
    if (url) {
      window.open(url);
    } else {
      open(errorPopup);
    }
  } else {
    open(errorPopup);
  }
}

export function emailBodyCellTemplate(container, info) {
  const element = document.createElement("div");
  element.classList.add(BLOCK_CLASS);
  const subjectContainer = document.createElement("div");
  subjectContainer.classList = `${BLOCK_CLASS}__subject`;
  subjectContainer.innerHTML = info.data["subject"];
  element.append(subjectContainer);

  if (info.data.generated_file) {
    const attachmentContainer = document.createElement("div");
    const attachmentLink = document.createElement("a");
    attachmentContainer.textContent = `${getUITranslation("Pièce jointe :")} `;
    attachmentLink.textContent = info.data.generated_file.original_filename;
    attachmentLink.href = "#";
    attachmentLink.classList = `${BLOCK_CLASS}__attachment`;
    attachmentLink.addEventListener("click", getAttachmentFile.bind(info.data));
    attachmentContainer.append(attachmentLink);
    element.append(attachmentContainer);
  }

  if (info.data.cc && info.data.cc.length > 0) {
    const ccContainer = document.createElement("div");
    ccContainer.classList = `${BLOCK_CLASS}__cc`;
    ccContainer.textContent = `${getUITranslation("Cc :")} ${info.data.cc}`;
    element.append(ccContainer);
  }

  const bodyContainer = document.createElement("div");
  // body must be sanitized in the backend
  bodyContainer.innerHTML = info.data.body;
  bodyContainer.classList.add("has-font-regular");
  element.append(bodyContainer);
  container.append(element);
}

export function shortenIfTooLongCellTemplate(dataElementName) {
  return (container, info) => {
    const newContainer = document.createElement("div");
    const text = info.data[dataElementName];

    if (text.length > MAX_CELL_LENGTH) {
      newContainer.textContent = text.substr(0, MAX_CELL_LENGTH);
      const seeMore = document.createElement("span");
      seeMore.classList = `${BLOCK_CLASS}__recipient--see-more`;
      seeMore.textContent = ". . .";
      seeMore.addEventListener("click", (e) => {
        newContainer.textContent = text;
        e.target.remove();
      });
      newContainer.append(seeMore);
    } else {
      newContainer.textContent = text;
    }

    container.append(newContainer);
  };
}

export function showDateTimeForProperty(property) {
  return (container, options) => {
    const value = options.data[property];

    // We don't want to use the datetime dataType in tabular_fields, as they make the filter require
    // time, which is pointless. We still want the content to show a datetime though
    //
    // An event-based automation has no date (it fires on its trigger), and moment would render "Invalid date".
    container.textContent = value ? moment(moment.utc(value).toDate()).format("DD/MM/YYYY HH:mm") : "";
  };
}

export function typeWithAttachmentCell(container, options) {
  container.textContent = options.data.type;
  if (hasGeneratedFile(options)) {
    const generatedFileLink = document.createElement("a");
    generatedFileLink.href = "#";
    generatedFileLink.style = "float: right;";

    generatedFileLink.appendChild(Icon.create("file"));
    generatedFileLink.addEventListener("click", getAttachmentFile.bind(options.data));

    container.append(generatedFileLink);
  }
}

export function statusCellTemplate(container, options) {
  container.classList.add(`${BLOCK_CLASS}__status--${options.data.status}`);
  container.textContent = options.data.formatted_status;

  // Show the provider webhook failure reason on hover when the email could not be delivered.
  if (options.data.error_message) {
    container.title = options.data.error_message;
    container.style.cursor = "help";
  }
}

function hasGeneratedFile(options) {
  return options.data.generated_file?.original_filename && options.data.generated_file?.filepath;
}
